module.exports = __webpack_public_path__ + "img/logo.b9515fce.png";